export const OTHER_RECIPIENT = "Other";

export const SONG_RECIPIENTS = [
  "Husband",
  "Wife",
  "Partner",
  "Girlfriend",
  "Boyfriend",
  "Son",
  "Daughter",
  "Fiancé",
  "Father",
  "Mother",
  "Grandparent",
  "Grandson",
  "Granddaughter",
  "Sibling",
  "Friend",
  "Myself",
  OTHER_RECIPIENT,
] as const;

export const OTHER_OCCASION = "Something else...";

export const SONG_OCCASIONS = [
  "Just Because",
  "I Love You",
  "Birthday",
  "Anniversary",
  "Fathers Day",
  "Mothers Day",
  "Valentine's Day",
  "Missing You",
  "Thank You",
  "Apology",
  "Wedding",
  "Friendship",
  "In Memory",
  "Milestone",
  "Proposal",
  "Retirement",
  "Graduation",
  OTHER_OCCASION,
] as const;

export const ONBOARDING_GENRES = [
  "Hip-hop",
  "Country",
  "Electronic",
  "Pop",
  "R&B/Soul",
  "Rock",
  "Jazz",
  "Lo-fi",
  "Afrobeats",
  "Latin",
  "Classical",
  "Folk",
  "Ambient",
] as const;

export const MAX_GENRE_SELECTIONS = 3;
export const RECIPIENT_NAME_MAX_CHARS = 40;
export const RECIPIENT_OTHER_MAX_CHARS = 300;
export const OCCASION_OTHER_MAX_CHARS = 300;
export const RECIPIENT_SPECIAL_MIN_CHARS = 20;
export const RECIPIENT_SPECIAL_MAX_CHARS = 500;
export const HEART_MESSAGE_MAX_CHARS = 300;
